import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

const EMPTY_FORM = { email: "", full_name: "", password: "", role: "VIEWER" };

export default function InviteUserDialog({ open, onOpenChange, companyId, roles, onAdded }) {
  const [form, setForm] = useState(EMPTY_FORM);

  const invite = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/companies/${companyId}/users`, form);
      toast.success("Utente aggiunto", { description: form.email });
      onOpenChange(false);
      setForm(EMPTY_FORM);
      onAdded();
    } catch (err) {
      toast.error("Errore", { description: formatApiError(err) });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="invite-user-dialog">
        <DialogHeader>
          <DialogTitle>Aggiungi utente all'azienda</DialogTitle>
          <DialogDescription>Crea un nuovo utente o associa un utente esistente con un ruolo aziendale.</DialogDescription>
        </DialogHeader>
        <form onSubmit={invite} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="inv-name">Nome e cognome *</Label>
            <Input id="inv-name" required minLength={2} value={form.full_name}
              onChange={(e) => setForm({ ...form, full_name: e.target.value })} data-testid="invite-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="inv-email">Email *</Label>
            <Input id="inv-email" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="invite-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="inv-password">Password iniziale * (min. 8 caratteri)</Label>
            <Input id="inv-password" type="password" required minLength={8} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="invite-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Ruolo</Label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid="invite-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {roles.map((r) => (
                  <SelectItem key={r.role} value={r.role}>{r.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="invite-cancel">Annulla</Button>
            <Button type="submit" className="bg-green-700 hover:bg-green-800" data-testid="invite-submit">Aggiungi</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
